import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  RadioGroup,
  MultiAutocomplete,
  Hidden,
  Select,
} from '~/components/Form';
import { CRUDProfile, PesquisaTabela } from '~/components/Form/v2';
import {
  REL_VAZAONAOAUTORIZADA,
  // REL_VAZAO_NAO_AUTORIZADA,
} from '~/constants/default';
import { t } from '~/helpers';

function RelvazaonaoAutorizada() {
  const [open, setOpen] = useState(true);
  const [posto, setPosto] = useState(0);
  const [produto, setProduto] = useState(0);
  const [bico, setBico] = useState(0);

  const [valuePosto, setValuePosto] = React.useState([]);
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [valueBico, setValueBico] = React.useState(0);
  const [inputValueBico, setInputValueBico] = React.useState('');

  const [valueProduto, setValueProduto] = React.useState(0);
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  const [modoIdentificadoUsuario, setModoIdentificadoUsuario] = React.useState(
    null
  );

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const modoidentificadousuario = [
    { value: 'T', label: t('s.relatorio.geral.todas') },
    { value: '0', label: t('s.geral.opcoes.naoidentificado') },
    { value: '1', label: t('s.geral.opcoes.identificado') },
  ];

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal, idproduto } = params;

    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);
    const idBico = valueBico === 0 ? '' : valueBico;
    const idProduto = valueProduto === 0 ? '' : valueProduto;
    const idModoIdentificadoUsuarioValue =
      modoIdentificadoUsuario === null || modoIdentificadoUsuario === undefined
        ? 'todos'
        : modoIdentificadoUsuario;
    console.log(idModoIdentificadoUsuarioValue);
    return {
      ...params,
      idproduto: idProduto,
      idposto: idPosto,
      idbico: idBico,
      idModoIdentificadoUsuarioValue,
    };
  }

  async function handleCarregaBicos(value) {
    // await reference.current.setFieldValue('automaticobico', value);
    // await setYesOrNo(value);
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.vazaonaoautorizadalistagem')}
      relatorio="vazaonaoautorizadalistagem"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        idperfilrelatorio: '0',
        idgrupocamposistema: REL_VAZAONAOAUTORIZADA,
        modoidentificadousuariostr: 'T',
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          if (value[0]?.idposto === null) {
            setValuePosto(0);
            setInputValuePosto('');

            setValueBico(0);
            setInputValueBico('');

            setValueProduto(0);
            setInputValueProduto('');

            setPosto(0);
            setBico(0);
            setProduto(0);
          } else {
            setValuePosto(value);

            setPosto(value[0]?.idposto || 0);

            setValueBico(0);
            setInputValueBico('');

            setValueProduto(0);
            setInputValueProduto('');
          }
        }}
      />

      <Autocomplete
        name="idbico"
        label="bicoprodutobico"
        url="bicos"
        unique="idbico"
        title={t('s.menu.configuracao.bico')}
        value={valueBico}
        inputValue={inputValueBico}
        onChange={(event, newValue) => {
          setValueBico(newValue);
        }}
        onInputChange={(event, newInputValueBico) => {
          setInputValueBico(newInputValueBico);
        }}
        disabled={valuePosto.length === 0 || valuePosto.length > 1}
        getValue={(value) => {
          setValueBico(value.idbico);
          setValueProduto(0);
          setInputValueProduto('');

          const formidproduto = document.getElementById('idproduto');
          formidproduto.innerText = '';

          if (value.idbico === null) {
            setBico(0);
            setProduto(0);
          } else {
            setProduto(value.idproduto);
            setBico(value.idbico);
          }
        }}
        params={{
          wherefield: 'idposto',
          valuewherefield: posto,
          typewherefield: 'EQUALS',
        }}
      />

      <Autocomplete
        id="idproduto"
        name="idproduto"
        label="nomeabreviadoproduto"
        url="produtos"
        unique="idproduto"
        disabled={bico !== 0}
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProduto) => {
          setInputValueProduto(newInputValueProduto);
        }}
        getValue={(value) => {
          if (value.idproduto !== null) {
            setValueProduto(value.idproduto);
          } else {
            setValueProduto(0);
          }

          setValueBico(0);
          setInputValueBico('');
        }}
        title={t('s.menu.configuracao.produto')}
        defaultValue=""
        hiddens={[{ name: 'nomeabreviadoproduto' }]}
      />

      {/* <Autocomplete
        name="idposto"
        label="nomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.menu.configuracao.posto')}
        //first={[{ nomeposto: 'TODOS', value: '' }]}
        value={valuePosto}
        inputValue={inputValuePosto}
        onChange={(event, newValue) => {
          setValuePosto(newValue);
        }}
        onInputChange={(event, newInputValuePosto) => {
          setInputValuePosto(newInputValuePosto);
        }}


        defaultValue=""
        hiddens={[{ name: 'nomeposto' }]}
        //getValue={({ idposto }) => setPosto(idposto)}
        getValue={
          (value) => {
            setValueBico(0);
            setInputValueBico('');
            if (value.idposto !== null) {
              setPosto(Number(value.idposto));
              setValuePosto(Number(value.idposto));
            } else {
              setPosto(0)
              setValuePosto(0);
            }
            //({ idposto }) => setPosto(Number(idposto));

          }
        }

      />

      <Autocomplete
        name="idbico"
        label="bicoprodutobico"
        url="bicos"
        unique="idbico"
        title={t('s.menu.configuracao.bico')}
        //first={[{ idbico: 'TODOS', value: '' }]}
        defaultValue=""
        hiddens={[{ name: 'idbico' }]}
        disabled={posto === 0}
        params={{
          wherefield: 'idposto',
          valuewherefield: posto,
          typewherefield: 'EQUALS',
          fieldlist: 'idbico, idproduto',
        }}

        value={valueBico}
        inputValue={inputValueBico}
        onChange={(event, newValue) => {
          setValueBico(newValue);
        }}
        onInputChange={(event, newInputValueBico) => {
          setInputValueBico(newInputValueBico);
        }}
        getValue={(value) => {
            setValueBico(value.idbico);
            setProduto(value.idproduto);
          }
        }

        //getValue={({ idproduto }) => setProduto(idproduto)}
      />

      <Autocomplete
        name="idproduto"
        label="nomeabreviadoproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        //first={[{ nomeabreviadoproduto: 'TODOS', value: '' }]}
        defaultValue=""
        hiddens={[{ name: 'nomeabreviadoproduto' }]}
        disabled={valueBico !== 0}
        params={{
          wherefield: 'idproduto',
          valuewherefield: produto,
          typewherefield: 'EQUALS',
          fieldlist: 'idproduto, nomeabreviadoproduto',
        }}
      /> */}

      <PesquisaTabela
        name="codigousuario"
        label={t('s.relatorio.abastecimentocontingencia.frentista')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cellsUser}
      />

      <Select
        name="modoidentificadousuariostr"
        variant="outlined"
        size="small"
        label={t('s.operacao.vazoanaoautorizada.modoidentificadousuariostr')}
        options={modoidentificadousuario}
        getValue={(value) => {
          setModoIdentificadoUsuario(value);
        }}
      />

      <CRUDProfile
        name="idperfilrelatorio"
        label={t('s.menu.cadastro.usuario.perfil')}
        report={REL_VAZAONAOAUTORIZADA}
        nameReport={t('s.menu.operacao.vazaonaoautorizada')}
      />

      <Hidden name="idgrupocamposistema" />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelvazaonaoAutorizada;
